// Generated W layer lookup table
// Contains flattened taxonomy for Worlds

export const W_LAYER_LOOKUP = {
  CLB: {
    numericCode: '001',
    name: 'Dance_Clubs',
  },
  'CLB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CLB.NEO': {
    numericCode: '002',
    name: 'Neon',
  },
  'CLB.VIP': {
    numericCode: '003',
    name: 'VIP_Lounge',
  },
  'CLB.RTF': {
    numericCode: '004',
    name: 'Rooftop',
  },
  'CLB.UND': {
    numericCode: '005',
    name: 'Underground',
  },
  'CLB.RET': {
    numericCode: '006',
    name: 'Retro',
  },
  'CLB.BCH': {
    numericCode: '007',
    name: 'Beach_Club',
  },
  STG: {
    numericCode: '002',
    name: 'Concert_Stages',
  },
  'STG.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'STG.ARE': {
    numericCode: '002',
    name: 'Arena',
  },
  'STG.FES': {
    numericCode: '003',
    name: 'Festival',
  },
  'STG.THE': {
    numericCode: '004',
    name: 'Theater',
  },
  'STG.OPE': {
    numericCode: '005',
    name: 'Open_Air',
  },
  'STG.LED': {
    numericCode: '006',
    name: 'LED_Stage',
  },
  URB: {
    numericCode: '003',
    name: 'Urban',
  },
  'URB.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'URB.CTY': {
    numericCode: '002',
    name: 'City',
  },
  'URB.STR': {
    numericCode: '003',
    name: 'Street',
  },
  'URB.SBW': {
    numericCode: '004',
    name: 'Subway',
  },
  'URB.SKY': {
    numericCode: '005',
    name: 'Skyscraper',
  },
  'URB.MKT': {
    numericCode: '006',
    name: 'Market',
  },
  BCH: {
    numericCode: '004',
    name: 'Beach',
  },
  'BCH.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'BCH.TRO': {
    numericCode: '002',
    name: 'Tropical',
  },
  'BCH.SUN': {
    numericCode: '003',
    name: 'Sunset',
  },
  'BCH.WAV': {
    numericCode: '004',
    name: 'Waves',
  },
  'BCH.PAL': {
    numericCode: '005',
    name: 'Palm',
  },
  NTL: {
    numericCode: '005',
    name: 'Natural',
  },
  'NTL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'NTL.FOR': {
    numericCode: '002',
    name: 'Forest',
  },
  'NTL.MTN': {
    numericCode: '003',
    name: 'Mountain',
  },
  'NTL.DSR': {
    numericCode: '004',
    name: 'Desert',
  },
  'NTL.LKE': {
    numericCode: '005',
    name: 'Lake',
  },
  FAN: {
    numericCode: '006',
    name: 'Fantasy',
  },
  'FAN.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'FAN.FAI': {
    numericCode: '002',
    name: 'Fairy',
  },
  'FAN.DRG': {
    numericCode: '003',
    name: 'Dragon',
  },
  'FAN.MAG': {
    numericCode: '004',
    name: 'Magic',
  },
  'FAN.ENC': {
    numericCode: '005',
    name: 'Enchanted',
  },
  'FAN.MYT': {
    numericCode: '006',
    name: 'Mythical',
  },
  FUT: {
    numericCode: '007',
    name: 'Futuristic',
  },
  'FUT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'FUT.CYB': {
    numericCode: '002',
    name: 'Cyberpunk',
  },
  'FUT.SPC': {
    numericCode: '003',
    name: 'Space',
  },
  'FUT.HOL': {
    numericCode: '004',
    name: 'Holographic',
  },
  'FUT.TEC': {
    numericCode: '005',
    name: 'Tech',
  },
  VIR: {
    numericCode: '008',
    name: 'Virtual',
  },
  'VIR.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'VIR.MET': {
    numericCode: '002',
    name: 'Metaverse',
  },
  'VIR.SIM': {
    numericCode: '003',
    name: 'Simulation',
  },
  'VIR.VRD': {
    numericCode: '004',
    name: 'VR_Dreamscape',
  },
  IND: {
    numericCode: '009',
    name: 'Industrial',
  },
  'IND.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'IND.FAC': {
    numericCode: '002',
    name: 'Factory',
  },
  'IND.WRH': {
    numericCode: '003',
    name: 'Warehouse',
  },
  'IND.MCH': {
    numericCode: '004',
    name: 'Machine',
  },
  RUR: {
    numericCode: '010',
    name: 'Rural',
  },
  'RUR.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RUR.FRM': {
    numericCode: '002',
    name: 'Farm',
  },
  'RUR.FLD': {
    numericCode: '003',
    name: 'Field',
  },
  'RUR.VIL': {
    numericCode: '004',
    name: 'Village',
  },
  HST: {
    numericCode: '011',
    name: 'Historical',
  },
  'HST.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'HST.MED': {
    numericCode: '002',
    name: 'Medieval',
  },
  'HST.REN': {
    numericCode: '003',
    name: 'Renaissance',
  },
  'HST.VIC': {
    numericCode: '004',
    name: 'Victorian',
  },
  CUL: {
    numericCode: '012',
    name: 'Cultural',
  },
  'CUL.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'CUL.AFR': {
    numericCode: '002',
    name: 'African',
  },
  'CUL.ASN': {
    numericCode: '003',
    name: 'Asian',
  },
  'CUL.LAT': {
    numericCode: '004',
    name: 'Latin',
  },
  ABS: {
    numericCode: '013',
    name: 'Abstract',
  },
  'ABS.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'ABS.GEO': {
    numericCode: '002',
    name: 'Geometric',
  },
  'ABS.SUR': {
    numericCode: '003',
    name: 'Surreal',
  },
  'ABS.GLT': {
    numericCode: '004',
    name: 'Glitch',
  },
  RET: {
    numericCode: '014',
    name: 'Retro',
  },
  'RET.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'RET.SIX': {
    numericCode: '002',
    name: '60s',
  },
  'RET.SEV': {
    numericCode: '003',
    name: '70s',
  },
  'RET.EGT': {
    numericCode: '004',
    name: '80s',
  },
  NAT: {
    numericCode: '015',
    name: 'Nature',
  },
  'NAT.BAS': {
    numericCode: '001',
    name: 'Base',
  },
  'NAT.FOR': {
    numericCode: '002',
    name: 'Forest',
  },
  'NAT.MTN': {
    numericCode: '003',
    name: 'Mountain',
  },
  'NAT.OCE': {
    numericCode: '004',
    name: 'Ocean',
  },
};

export const W_SUBCATEGORIES = {
  CLB: [
    'CLB.BAS',
    'CLB.NEO',
    'CLB.VIP',
    'CLB.RTF',
    'CLB.UND',
    'CLB.RET',
    'CLB.BCH',
  ],
  STG: ['STG.BAS', 'STG.ARE', 'STG.FES', 'STG.THE', 'STG.OPE', 'STG.LED'],
  URB: ['URB.BAS', 'URB.CTY', 'URB.STR', 'URB.SBW', 'URB.SKY', 'URB.MKT'],
  BCH: ['BCH.BAS', 'BCH.TRO', 'BCH.SUN', 'BCH.WAV', 'BCH.PAL'],
  NTL: ['NTL.BAS', 'NTL.FOR', 'NTL.MTN', 'NTL.DSR', 'NTL.LKE'],
  FAN: ['FAN.BAS', 'FAN.FAI', 'FAN.DRG', 'FAN.MAG', 'FAN.ENC', 'FAN.MYT'],
  FUT: ['FUT.BAS', 'FUT.CYB', 'FUT.SPC', 'FUT.HOL', 'FUT.TEC'],
  VIR: ['VIR.BAS', 'VIR.MET', 'VIR.SIM', 'VIR.VRD'],
  IND: ['IND.BAS', 'IND.FAC', 'IND.WRH', 'IND.MCH'],
  RUR: ['RUR.BAS', 'RUR.FRM', 'RUR.FLD', 'RUR.VIL'],
  HST: ['HST.BAS', 'HST.MED', 'HST.REN', 'HST.VIC'],
  CUL: ['CUL.BAS', 'CUL.AFR', 'CUL.ASN', 'CUL.LAT'],
  ABS: ['ABS.BAS', 'ABS.GEO', 'ABS.SUR', 'ABS.GLT'],
  RET: ['RET.BAS', 'RET.SIX', 'RET.SEV', 'RET.EGT'],
  NAT: ['NAT.BAS', 'NAT.FOR', 'NAT.MTN', 'NAT.OCE'],
};
